<template>
  <div>
    <v-tabs v-model="tab" centered v-if="contract.id">
      <v-tab>{{ $t('menuHeaders.info') }}</v-tab>
      <v-tab>{{ $t('menuHeaders.workflows') }}</v-tab>
      <v-tab>{{ $t('menuHeaders.documents') }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <component
          :is="isFormDisplayed ? 'ContractForm' : 'ContractInfo'"
          :contract="contract"
          :key="contract.id"
          @toggle-edit="contractEditMode = !contractEditMode"
          :isEditMode="contractEditMode"
        />
      </v-tab-item>
      <v-tab-item>
        <WorkflowsTab
          :contract="contract"
          @update-workflows="$eventBus.$emit('FETCH_CONTRACT')"
        />
      </v-tab-item>
      <v-tab-item>
        <documents :documents="contract.documents"/>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { DEFAULT_CONTRACT } from '@/helpers'

export default {
  name: 'ContractView',
  props: {
    contract: {
      type: Object,
      default: () => DEFAULT_CONTRACT
    }
  },
  data () {
    return {
      tab: 0,
      contractEditMode: false
    }
  },
  computed: {
    isFormDisplayed () {
      return this.$route.name === 'new contract' || this.contractEditMode
    }
  },
  mounted () {
    this.$eventBus.$emit('FETCH_CONTRACT')
  }
}
</script>
